import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEdit, FaEye } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Modal from "../ui/Modal";
import CouponEdit from "../Coupon/CouponEdit";
import CouponView from "../Coupon/CouponView";
import Button from "../ui/Button";
import "../../assets/css/style.css";
const DebouncedInput = ({
  value: initValue,
  onChange,
  debounce = 500,
  ...props
}) => {
  const [value, setValue] = useState(initValue);
  useEffect(() => {
    setValue(initValue);
  }, [initValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);
    return () => clearTimeout(timeout);
  }, [value]);
  
  return (
    <input
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
};

const Coupon = () => {
  const columnHelper = createColumnHelper();
  const [data, setData] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/coupon`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "An unexpected error occurred";
        toast.error(errorMessage);
      });
  }, []);
  const addCoupon = (data) => {
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/coupon`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        toast.success("Coupon added successfully");
        console.log(response.data.data);
        setData(
          (prevData) => [...prevData, response.data.data]
        );
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "An unexpected error occurred";
        toast.error(errorMessage);
      });
      
  }
  const updateCoupon = (updatedData) => {
    axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/coupon/${updatedData.id}`, updatedData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      toast.success("Coupon updated successfully");
      const index = data.findIndex((coupon) => coupon._id === response?.data?.data._id);
      const updatedData = [...data];
      updatedData[index] = response.data.data;
      setData(updatedData);
    })
    .catch((error) => {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      toast.error(errorMessage);
    });
  }
  const deleteCoupon = (id) => {
    axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/coupon/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(() => {
      toast.success("Coupon deleted successfully");
      setData(data.filter((coupon) => coupon._id !== id));
    })
    .catch((error) => {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      toast.error(errorMessage);
    });
  }

  const columns = [
    columnHelper.accessor("id", {
      id: "S.No",
      cell: (info) => <span>{info.row.index + 1}</span>,
      header: "S.No",
    }),
    columnHelper.accessor("code", {
      cell: (info) => (
        <div
          dangerouslySetInnerHTML={{ __html: info.getValue() }}
          className="line-clamp-3"
        />
      ),
      header: "Coupon",
    }),
    columnHelper.accessor("discountPercentage", {
      cell: (info) => (
        <div
          dangerouslySetInnerHTML={{ __html: `${info.getValue()}%` }}
          className="line-clamp-3"
        />
      ),
      header: "Discount %",
    }),
    columnHelper.accessor("expiryDate", {
      cell: (info) => (
        <div
          dangerouslySetInnerHTML={{ __html: moment(info.getValue()).format("DD-MM-YYYY")
          }}
          className="line-clamp-3"
        />
      ),
      header: "Expiry Date",
    }),
    columnHelper.accessor("maxRedemptions", {
      cell: (info) => (
        <div
          dangerouslySetInnerHTML={{ __html: info.getValue()
          }}
          className="line-clamp-3"
        />
      ),
      header: "Max Redemptions",
    }),
    columnHelper.accessor("usedCount", {
      cell: (info) => (
        <div
          dangerouslySetInnerHTML={{ __html: info.getValue()
          }}
          className="line-clamp-3"
        />
      ),
      header: "Used Count",
    }),
    columnHelper.accessor("isActive", {
      cell: (info) => (
        <div
          dangerouslySetInnerHTML={{ __html: info.getValue() ? "Yes" : "No"
          }}
          className="line-clamp-3"
        />
      ),
      header: "Active",
    }),
    columnHelper.accessor("actions", {
      cell: (info) => (
        <div className="flex items-center space-x-2">
          
          <button
            onClick={() => {
              setSelectedId(
                info.row.original._id
              );
              setIsEditOpen(true);
            }}
            className="view-icon"
          >
            <FaEdit 
              fontSize={20}
            />
          </button>
          <button
            onClick={() => {
              
              setSelectedId(
                info.row.original._id
              );
              deleteCoupon(
                info.row.original._id
              );
            }}
            className="view-icon"
          >
            <MdDelete
              fontSize={20}

            />
          </button>
          
          </div>
      ),
      header: "Actions",
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    state: {
      globalFilter,
    },
    getFilteredRowModel: getFilteredRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  return (
    <>
    <Modal
      isOpen={isEditOpen}
      onClose={
        () => setIsEditOpen(false)
      }
      title="Coupon Edit"
      className="max-w-2xl"
    >
    <CouponEdit
  initialData={data.find((coupon) => coupon._id === selectedId)}
  onSubmit={(data) => {
    updateCoupon({id:selectedId,...data});
    setIsEditOpen(false);
  }}
/>
    </Modal>
    <Modal
      isOpen={isAddOpen}
      onClose={
        () => setIsAddOpen(false)
      }
      title="Coupon Add"
      className="max-w-2xl"
    >
    <CouponEdit
    
  onSubmit={(data) => {
    addCoupon(data);
    setIsAddOpen(false);
  }}
/>
    </Modal>    
    <Modal
        isOpen={isViewOpen}
        onClose={
          () => setIsViewOpen(false)
        }
        title="Coupon Details"
        className="max-w-2xl"
        >
        <CouponView
            name={
                data.find((coupon) => coupon._id === selectedId)?.name
            }
            description={
                data.find((coupon) => coupon._id === selectedId)?.description
            }
        />
    </Modal>
    <div className="bg-white p-2 mx-auto fill-gray-400">
      <ToastContainer />
      <div className="flex justify-between mb-2">
        <div className="w-full flex items-center gap-1">
          <i className="fas fa-search"></i>
          <DebouncedInput
            value={globalFilter ?? ""}
            onChange={(value) => setGlobalFilter(String(value))}
            className="p-2 bg-transparent outline-none border-b-2 w-1/5 focus:w-1/3 duration-300 border-gray-300"
            placeholder="Search all columns..."
          />
        </div>
        <Button
        onClick={() => setIsAddOpen(true)}
        className="black-button whitespace-nowrap"
        >
          Add Coupon
        </Button>
      </div>
      <table className="w-full text-left">
        <thead className="bg-black text-white">
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th key={header.id} className="capitalize px-3.5 py-2">
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.length ? (
            table.getRowModel().rows.map((row, i) => (
              <tr
                key={row.id}
                className={`${i % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
              >
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id} className="px-3.5 py-4 text-black">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr className="text-center h-32">
              <td colSpan={12}>
                {" "}
                <i className="fa-solid fa-spinner animate-spin text-2xl"></i>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="flex items-center justify-end mt-2 gap-2">
        <button
          onClick={() => {
            table.previousPage();
          }}
          disabled={!table.getCanPreviousPage()}
          className="p-1 border border-gray-700 px-2 disabled:opacity-50 text-gray-700"
        >
          {"<"}
        </button>
        <button
          onClick={() => {
            table.nextPage();
          }}
          disabled={!table.getCanNextPage()}
          className="p-1 border border-gray-700 px-2 disabled:opacity-50 text-gray-700"
        >
          {">"}
        </button>

        <span className="flex items-center gap-1 text-gray-700">
          <div>Page</div>
          <strong>
            {table.getState().pagination.pageIndex + 1} of{" "}
            {table.getPageCount()}
          </strong>
        </span>
        <span className="flex items-center gap-1 text-gray-700">
          | Go to page:
          <input
            type="number"
            min={1}
            defaultValue={table.getState().pagination.pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              table.setPageIndex(page);
            }}
            className="border border-gray-700 p-1 rounded w-16 outline-none focus:outline-none"
          />
        </span>
        <select
          value={table.getState().pagination.pageSize}
          onChange={(e) => {
            table.setPageSize(Number(e.target.value));
          }}
          className="p-1 border border-gray-700 text-gray-700"
        >
          {[5, 10, 25, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
    </div></>
    
  );
};

export default Coupon;

